import { motion } from "framer-motion";
import { track } from "@/track";
import { MessageCircle, Phone } from "lucide-react";

export default function FloatingActions() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-24 md:bottom-6 right-6 z-50 flex flex-col gap-3"
      data-testid="floating-actions"
    >
      <motion.a
        href="tel:+14039785035"
        aria-label="Call us"
        onClick={() => track("call_click")}
        data-testid="floating-call-btn"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-navy-800/90 backdrop-blur-xl border border-brand/40 text-brand-300 shadow-[0_8px_30px_rgba(0,0,0,0.45)] hover:border-brand hover:bg-brand hover:text-white transition-colors duration-300"
      >
        <Phone size={22} />
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap bg-navy-800 border border-brand/25 text-cream text-xs tracking-wide px-3 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Call +1 403 978 5035
        </span>
      </motion.a>

      <motion.a
        href="https://wa.me/14039785035"
        target="_blank"
        onClick={() => track("whatsapp_click")}
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="floating-whatsapp-btn"
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-brand text-white shadow-[0_8px_30px_rgba(99,102,241,0.45)] hover:bg-brand-600 transition-colors duration-300"
      >
        <span className="absolute inset-0 rounded-full bg-brand/50 animate-ping [animation-duration:2.5s]" aria-hidden="true" />
        <MessageCircle size={24} className="relative" />
        <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap bg-navy-800 border border-brand/25 text-cream text-xs tracking-wide px-3 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
          Chat on WhatsApp
        </span>
      </motion.a>
    </motion.div>
  );
}
